export class FirmaUtils {
  /**
   * Retorna el tipo de firma y su modalidad.
   *
   * Ejemplos:
   * Firma simple
   * Firma normal - Por grupo
   * Firma normal - Por plantilla
   * Firma externa - Por plantilla
   */
  static getTipoFirma(
    firmaSimple: boolean,
    idServicioExterno: string | null | undefined,
    esGrupo: boolean,
    firmaPorPlantilla: boolean,
  ): string {
    let tipoFirma: string;

    // Tipo de firma
    if (firmaSimple) {
      tipoFirma = "Simple";
    } else if (idServicioExterno) {
      tipoFirma = "Sobre externo";
    } else {
      tipoFirma = "Sobre";
    }

    // Modalidad
    if (esGrupo) {
      return `${tipoFirma} - Por grupo`;
    }

    if (firmaPorPlantilla) {
      return `${tipoFirma} - Por plantilla`;
    }

    return tipoFirma;
  }

  /**
   * Retorna el icono correspondiente al tipo de firma.
   */
  static getIconFirma(
    firmaSimple: boolean,
    idServicioExterno: string | null | undefined,
    esGrupo: boolean,
    firmaPorPlantilla: boolean,
  ): string {
    let iconFirma: string;

    // Tipo de firma
    if (firmaSimple) {
      iconFirma = "fa-solid fa-signature";
    } else if (idServicioExterno) {
      iconFirma = "fa-solid fa-file-export";
    } else {
      iconFirma = "fa-solid fa-file-signature";
    }

    // Modalidad
    if (esGrupo) {
      return "fa-solid fa-users";
    }

    if (firmaPorPlantilla) {
      return "fa-solid fa-file-lines";
    }

    return iconFirma;
  }

  static getStyleFirma(
    firmaSimple: boolean,
    idServicioExterno: string | null | undefined,
    esGrupo: boolean,
    firmaPorPlantilla: boolean,
  ): { background: string; color: string } {
    let background: string;

    // Firma simple - Verde
    if (firmaSimple) {
      background = "#198754";

      // Firma externa - Morado
    } else if (idServicioExterno) {
      background = "#6F42C1";

      // Por grupo - Naranja
    } else if (esGrupo) {
      background = "#FD7E14";

      // Por plantilla - Turquesa
    } else if (firmaPorPlantilla) {
      background = "#0DCAF0";

      // Firma normal - Azul
    } else {
      background = "#0D6EFD";
    }

    return {
      background,
      color: "#FFFFFF",
    };
  }
}
